import React from 'react';
import { withRouter } from 'react-router-dom';
import Routes from "./routes";
import { ContextProvider } from './contexts';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/global';
import theme from './styles/theme';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

const AppWrapper = () => (
    <ContextProvider>
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <ToastContainer style={{ zIndex: 999999999 }}
                position='bottom-right'
                className='ToastContainer'
                hideProgressBar={false}
                newestOnTop={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Routes />
        </ThemeProvider>
    </ContextProvider>
);

export default withRouter(AppWrapper);
